import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import IcoTxViewLayer from "../../components/Ico/IcoTxViewLayer";

const IcoTxViewPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="ICO Transaction Details" />
                    <IcoTxViewLayer />
               </MasterLayout>
          </>
     );
};

export default IcoTxViewPage;
